'use client';

import type { StateAbbreviation } from '@repo/supergraph/marketplace/types';
import { SummaryTableRowType } from '@repo/supergraph/roundup/base/types';
import { snakeCase } from 'lodash';
import { useRef } from 'react';
import { OffersFilterStoreProvider } from '../roundups/OffersFilter';
import { OffersFilter } from '../roundups/OffersFilter/OffersFilter';

type WrapperProps = {
  children: React.ReactNode;
  initialLocation?: StateAbbreviation;
  isFilterActive?: boolean;
  pageSlug: string;
  filterSlug?: string;
  sortedRows: SummaryTableRowType[];
};

function Wrapper({
  children,
  isFilterActive,
  pageSlug,
  filterSlug,
  initialLocation,
  sortedRows,
}: WrapperProps) {
  const filteredProductsRef = useRef<HTMLDivElement>(null);

  if (!isFilterActive || !filterSlug) {
    return <>{children}</>;
  }

  const snakeCasedPageSlug = snakeCase(pageSlug);
  const analyticsProps = {
    actionSection: `banking_${snakeCasedPageSlug}_filter`,
    pageIdentifier: snakeCasedPageSlug,
  };

  return (
    <OffersFilterStoreProvider offers={sortedRows} slug={filterSlug}>
      <OffersFilter
        slug={filterSlug}
        initialLocation={initialLocation}
        analyticsProps={analyticsProps}
        mainSectionRef={filteredProductsRef}
      />
      <div ref={filteredProductsRef}>{children}</div>
    </OffersFilterStoreProvider>
  );
}

export function ProductsSectionWrapper({
  children,
  isFilterActive,
  pageSlug,
  filterSlug,
  initialLocation,
  sortedRows,
}: WrapperProps) {
  return isFilterActive && filterSlug ? (
    <Wrapper
      isFilterActive={isFilterActive}
      pageSlug={pageSlug}
      filterSlug={filterSlug}
      initialLocation={initialLocation}
      sortedRows={sortedRows}
    >
      {children}
    </Wrapper>
  ) : (
    children
  );
}
